module.exports = __webpack_public_path__ + "fonts/DINPro-Regular.3d5fdeeb.ttf";